import React from "react";
import {
  Form,
  DatePicker,
  Input,
  Select,
  Button,
  Space,
  Row,
  Dropdown,
  message,
  Upload,
  Modal,
  Tooltip,
  Drawer,
  Image,
  Avatar,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import DisplayLocationMap from "./DisplayLocationMap";
import { SearchOutlined, CloseOutlined } from "@ant-design/icons";
import config from "../config";
import withRouter from "../withRouter";
import CompanyAutocomplete from "./CompanyAutocomplete";
import JobManagementAdd from "./JobManagementAdd";
import ListTable from "./ListTable";
import JobManagementStore from "../store/JobManagementStore";
import DriversStore from "../store/DriversStore";
import VehicleStore from "../store/VehicleStore";
import dayjs from "dayjs";
import CompanyStore from "../store/CompanyStore";
import DeliveryDashboardStore from "../store/DeliveryDashboardStore";
import editIcon from "../assets/images/NewDesign/editIcon.svg";
import kebabIcon from "../assets/images/NewDesign/kebab.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import uploadIcon from "../assets/images/NewDesign/upload.svg";
import sampleUploadIcon from "../assets/images/NewDesign/SampleUpload.svg";
import UploadTitleIcon from "../assets/images/NewDesign/UploadTitle.svg";
import uploadOutlined from "../assets/images/NewDesign/uploadOutlined.svg";
import sampleDownloadIcon from "../assets/images/NewDesign/SampleDownload.svg";

const { Dragger } = Upload;

let widthAdderFunc = (arr) => {
  let array = arr;
  array.map((val) => {
    if (val.title?.length > 24) {
      val.width = 230;
    } else if (val.title?.length > 15) {
      val.width = 200;
    } else if (val.title?.length > 12) {
      val.width = 130;
    } else if (val.title?.length > 8) {
      val.width = 110;
    } else {
      val.width = 80;
    }
  });

  return arr;
};
const { Option } = Select;
const currentDate = dayjs().format("MM-DD-YYYY");

class JobManagementList extends React.Component {
  constructor(props, context) {
    super(props);

    this.handleTableChange = this.handleTableChange.bind(this);
    this.jobManagementStore = new JobManagementStore(this);
    this.driverStore = new DriversStore(this);
    this.vehicleStore = new VehicleStore(this);
    this.companyStore = new CompanyStore(this);
    this.deliveryDashboardStore = new DeliveryDashboardStore(this);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      openConfirm: false,
      confirmLoading: false,
      loadList: 0,
      warehouseList: [],
      companyId: "",
      showUpload: false,
      showDeleteModal: false,
      // list search component
      vehicleId: "",
      openDeleteModal: false,

      deleteData: {},
      editData: {},

      deliveryDateFrom: dayjs().format("YYYY-MM-DD"),
      deliveryDateTo: dayjs().format("YYYY-MM-DD"),
      driverName: "",
      salesExecutive: "",
      customerName: "",
      showModal: false,
      jobId: "",

      showmap: false,

      companyVal_Lab: "",
      openJobmanagementForm: false,
      listDataUpdate: false,
      Id: "",
      showAlertModal: false,

      fileList: [],
      uploading: false,
      uploadProgress: 0,
      showCancelJobModal: false,
      cancelJobId: "",
      excelFile: "",
    };

    this.columns = widthAdderFunc([
      {
        title: context.translate("_JOB_NO_"),
        dataIndex: "Id",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Vehicle Number",
        title: context.translate("_VEHICLE_NO_"),
        dataIndex: "vehicleNo",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
        render: (value, record) => {
          return (
            <Tooltip placement="topLeft" title={value}>
              <Link
                style={{ color: "#2563EB", textDecoration: "none" }}
                onClick={(e) => {
                  e.preventDefault();
                  this.props.canUpdate("jobmanagementlist") &&
                    this.onEdit(record);
                }}
              >
                {value}
              </Link>
            </Tooltip>
          );
        },
      },
      {
        // title: "Driver Name",
        title: context.translate(
          "_FLEET_DASHBORD_VEHICLE_INFORMATION_DRIVERNAME_"
        ),
        dataIndex: "name",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Mobile No",
        title: context.translate("_FLEET_DASHBORD_VEHICLE_INFORMATION_MOBILE_"),
        dataIndex: "mobileno",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Customer Name ",
        title: context.translate("_CUSTOMER_NAME_"),
        dataIndex: "customerName",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Customer Name ",
        title: context.translate("_CUSTOMER_CODE_"),
        dataIndex: "customerCode",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Customer Mobile No",
        title: context.translate("_CUST_MOBILENO_"),
        dataIndex: "customerMobile",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Sales Executive Name",
        title: context.translate("_SALES_EXECUTIVE_NAME_"),
        dataIndex: "SalesExecutiveName",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Sales Coordinator Name",
        title: context.translate("_SALES_COORDINATOR_NAME_"),
        dataIndex: "SalesCoordinatorName",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Job To",
        title: context.translate("_JOB_TO_"),
        dataIndex: "jtype",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Job Date",
        title: context.translate("_JOB_DATE_"),
        dataIndex: "deliveryDate",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Job Time",
        title: context.translate("_JOB_TIME_"),
        dataIndex: "deliveryTime",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Job Type",
        title: context.translate("_JOB_TYPE_"),
        dataIndex: "pickupDelivery",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Job Type",
        title: context.translate("_ROUTE_ID_"),
        dataIndex: "routeId",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Job Type",
        title: context.translate("_ROUTE_NAME_"),
        dataIndex: "routeName",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Job Type",
        title: context.translate("_CREATED_DATE_"),
        dataIndex: "createDate",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Status",
        title: context.translate("_FLEET_DASHBORD_DROWGEO_ALERTSTATUS_"),
        dataIndex: "status",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
        render: (val) => {
          if (val == 3) {
            return "Delivered";
          } else if (val == 4) {
            return "Cancelled";
          } else {
            return "Pending";
          }
        },
      },
      {
        // title: "Status",
        title: context.translate("_ORDER_STATUS1_"),
        dataIndex: "orderStatus",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Action",
        title: context.translate("_ACTION_"),
        dataIndex: "groupname",
        align: "center",
        ellipsis: {
          showTitle: true,
        },
        render: (_, record) => {
          return (
            <>
              <Space>
                {this.props.canUpdate("jobmanagementlist") &&
                record.status != 4 ? (
                  <Tooltip
                    // title="Delete"
                    title={context.translate("_CANCEL_JOB_")}
                    placement="bottom"
                    color={config.tooltipColorEdit}
                  >
                    <Image
                      width={13}
                      src={require("../assets/images/cancel.png")}
                      onClick={(e) => {
                        this.setState({ showCancelJobModal: true });
                        this.setState({ cancelJobId: record.Id });
                      }}
                    ></Image>
                  </Tooltip>
                ) : (
                  <Space>
                    <span style={{ visibility: "hidden" }}>.....</span>
                  </Space>
                )}
                {/* {record.status != 4 && (
                  
                )} */}
                {this.props.canDelete("jobmanagementlist") && (
                  <Tooltip
                    title={this.context.translate("_DELETE_RECORD_")}
                    placement="bottom"
                  >
                    <Image
                      src={require("../assets/images/NewDesign/Delete.png")}
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        this.setState({
                          openDeleteModal: true,
                          deleteData: record,
                        })
                      }
                    ></Image>
                  </Tooltip>
                )}

                <Dropdown
                  // overlayClassName="export-dropdown"
                  menu={this.actionColumn}
                  trigger={["click"]}
                  style={{ cursor: "pointer" }}
                >
                  <Image
                    src={kebabIcon}
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ editData: record });
                    }}
                  ></Image>
                </Dropdown>
              </Space>
            </>
          );
        },
        width: "10%",
      },
    ]);

    this.actionColumn = {
      items: [
        this.props.canUpdate("jobmanagementlist") && {
          // label: "Excel",
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Avatar
                style={{ height: "16px", width: "16px", borderRadius: "0px" }}
                src={editIcon}
                onClick={() => this.onEdit(this.state.editData)}
              ></Avatar>
              {context.translate("_FLEET_ROLE_ROLEDETAIL_EDIT_")}
            </div>
          ),
          key: "edit",
          // icon: (

          // ),
        },
      ],
    };

    this.ExportMenuProps = {
      items: [
        {
          label: context.translate("_FINISH_JOB_"),
          key: "FinishJob",
        },
        {
          label: context.translate("_FLEET_DASHBORD_RULETRIGGER_DELETE_"),
          // icon: <i class="bi bi-trash3" style={{ marginRight: "5px" }}></i>,
          key: "DeleteJob",
        },
      ],
      onClick: async (val) => {
        if (val.key == "FinishJob") {
          this.state.jobId.length > 0
            ? await this.setState({ showModal: true })
            : await this.setState({ showAlertModal: true });
        }
        if (val.key == "DeleteJob") {
          this.state.jobId.length > 0
            ? await this.setState({ showDeleteModal: true })
            : await this.setState({ showAlertModal: true });
        }
      },
    };
  }
  onEdit = async (record) => {
    const Id = record.Id;

    if (Id) {
      await this.context.viewStateStore.setJobManagementStates(
        this.state.companyId,
        this.state.driverName,
        this.state.vehicleId,
        this.state.salesExecutive
      );
      // await this.props.navigate("/jobmanagementadd/" + Id);
      await this.setState({ Id: record.Id });
      await this.setState({ openJobmanagementForm: true });
    }
  };

  onDelete = async (record) => {
    const response = await this.jobManagementStore.deleteRecord({
      Id: record.Id,
      companyId: record.companyId,
    });

    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  };
  async componentDidMount() {
    if (Number(this.props.getUserData().isadmin) !== -1) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ userId: this.props.getUserData().userId });
      await this.jobManagementStore.getAllVehicles(
        this.props.getUserData().userCompanyId
      );
      await this.jobManagementStore.getDriversByCompanyId(
        this.props.getUserData().userCompanyId
      );
      await this.jobManagementStore.getSalesPersonExecutive({
        companyId: this.props.getUserData().userCompanyId,
      });
      // await this.handleSearch();
    }

    this.setState({ pageSize: 50 });
    this.menuProps = {
      items: [
        {
          // label: "Driver",
          label: this.context.translate("_FLEET_MANAGEVEHICLE_DRIVER_TAB_"),
          key: "driver",
        },
        {
          // label: "Sales Person",
          label: this.context.translate("_SALES_PERSON_"),
          key: "salesPerson",
        },
      ],
      onClick: (val) => {
        if (val.key == "driver") {
          this.jobManagementStore.sampleExcelDriver();
        }
        if (val.key == "salesPerson") {
          this.jobManagementStore.sampleExcelSalesPerson();
        }
      },
    };
  }

  async componentDidUpdate(prevProps, prevState) {
    if (this.state.showmap !== prevState.showma) {
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      });
    }
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      const setJobData = this.context.viewStateStore.jobManagementObject;

      if (setJobData.companyId !== "") {
        await this.jobManagementStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: setJobData.companyId,
          vehicleId: setJobData.vehicleId,
          driverName: setJobData.driverName,
          salesExecutive: setJobData.salesExecutive,
          deliveryDateFrom: this.state.deliveryDateFrom,
          deliveryDateTo: this.state.deliveryDateTo,
        });

        const data = await this.jobManagementStore.getAllVehicles(
          setJobData.companyId
        );

        await this.setState({ vehicleId: setJobData.vehicleId });

        await this.jobManagementStore.getDriversByCompanyId(
          setJobData.companyId
        );
        await this.setState({ driverName: setJobData.driverId });

        await this.jobManagementStore.getSalesPersonExecutive({
          companyId: setJobData.companyId,
        });
        await this.setState({ salesExecutive: setJobData.salespersonId });

        const singleData = await this.companyStore.getCompanyDataById(
          setJobData.companyId
        );

        await this.setState({ loadList: 1 });

        await this.setState({
          companyVal_Lab: singleData,
          companyId: setJobData.companyId,
        });
      }
      await this.setState({ listDataUpdate: false });
    }
  }
  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }
  async handleChange(comp) {
    await this.setState({
      companyId: comp.value,
      vehicleId: "",
      salesExecutive: "",
      driverName: "",
      jobId: "",
    });
    const singleData = await this.companyStore.getCompanyDataById(comp.value);
    await this.setState({ companyVal_Lab: singleData, companyId: comp.value });

    await this.jobManagementStore.getAllVehicles(comp.value);
    await this.jobManagementStore.getDriversByCompanyId(comp.value);
    await this.jobManagementStore.getSalesPersonExecutive({
      companyId: comp.value,
    });

    await this.handleSearch();
    await this.setState({ loadList: 1 });
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.jobManagementStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
      vehicleId: this.state.vehicleId,
      deliveryDateFrom: this.state.deliveryDateFrom,
      deliveryDateTo: this.state.deliveryDateTo,
      driverName: this.state.driverName,
      salesExecutive: this.state.salesExecutive,
      customerName: this.state.customerName,
    });

    await this.setState({ loadList: 1 });
  }
  searchClick = async () => {
    if (!this.state.companyId) {
      this.setState({ companyFieldHighlight: true });
    } else {
      this.setState({ companyFieldHighlight: false });
    }
    if (this.state.companyId) {
      this.setState({ companyFieldHighlight: false, loading: true });

      await this.jobManagementStore.loadData({
        offset: (this.state.currentPage - 1) * this.state.pageSize,
        limit: this.state.pageSize,
        companyId: this.state.companyId,
        vehicleId: this.state.vehicleId,
        deliveryDateFrom: this.state.deliveryDateFrom,
        deliveryDateTo: this.state.deliveryDateTo,
        driverName: this.state.driverName,
        salesExecutive: this.state.salesExecutive,
        customerName: this.state.customerName,
      });
      await this.setState({ loadList: 1 });
    }
  };

  getUploadData = async (fileUp) => {
    // if (fileUp.status !== 'uploading') {

    let fileinfo = await fileUp.file.response;

    if (fileinfo?.success == "S") {
      await this.setState({ excelFile: fileinfo.data });
    }

    this.setState({ update: 1 });
  };

  onExcelSubmit = async (fieldsValue) => {
    const data = {
      ...fieldsValue,
      companyId: this.state.companyId,
      excelFile: this.state.excelFile,
    };
    const resp = await this.jobManagementStore.addDriverByExcel(data);
    if (resp?.success == "S") {
      if(resp.message.includes("Data imported successfully")){
        message.success(resp.message);
      }else{
        message.warning(resp.message);
      }
      this.setState({ showUpload: false });
      this.setState({ excelFile: "" });
    } else {
      message.error(resp.message);
    }
  };

  finishJob = async (value) => {
    const data = {
      JobIdArray: value,
    };
    const resp = await this.jobManagementStore.finishJob(data);
    // const resp = {};
    if (resp?.success == "S") {
      message.success(resp.message);
      await this.handleSearch();
    }
    if (resp.message) {
      this.setState({ showUpload: false });
      this.setState({ jobId: [] });
      // this.formRef.current?.resetFields();
    } else {
      if (resp.errors[0]) {
        message.error(resp.errors[0]);
      }
    }
  };

  deleteJob = async (value) => {
    let flag = 0;

    const deleteJob = value.forEach(async (id) => {
      const data = {
        Id: id,
        companyId: this.state.companyId,
      };

      const response = await this.jobManagementStore.deleteRecord(data);

      if (response?.data?.success === "S") {
        if (flag === 0) {
          message.success(response.data.message);
        }

        this.handleSearch();
        flag++;
      } else {
        message.error(response.data.message);
      }
    });
  };

  show = () => {
    this.setState({ showmap: true });
  };

  responseMsg = async (resp) => {
    if (resp.success == "S") {
      const isEdit = this.state.Id;
      message.success(isEdit ? "Updated Successfully" : resp.message);
      await this.setState({ listDataUpdate: true });
      await this.setState({ openJobmanagementForm: false });

      await this.handleSearch();
      // this.props.navigate("/jobmanagementlist");
    } else {
      message.error(resp.message);
    }
  };

  closeModal = () => {
    this.setState({ openJobmanagementForm: false, Id: "" });
  };

  handleReasonToCancel = async (val) => {
    console.log(val);
    const data = {
      tokenId: "",
      companyId: this.state.companyId,
      userId: 1,
      Id: this.state.cancelJobId,
      reason: val.reason,
    };

    const res = await this.jobManagementStore.cancelJob(data);
    if (res.success === "S") {
      message.success(res.message);
      await this.handleSearch();
      this.setState({ showCancelJobModal: false, showCofirmJobModal: false });
    }
  };

  handleDashboardClick = async () => {
    await this.deliveryDashboardStore.loadData({
      companyId: this.props.getUserData().userCompanyId,
      fromDate: dayjs().format("YYYY-MM-DD"),
      toDate: dayjs().format("YYYY-MM-DD"),
      filter: "all",
      datefilter: dayjs().format("YYYY-MM-DD"),
      statusFilter: null,
      invoiceDate: "",
    });
  };

  refreshList = async () => {
    if (this.state.companyId) {
      this.setState({ loading: true });
      await this.jobManagementStore.loadData({
        offset: 0,
        limit: 50,
        companyId: this.state.companyId,
        vehicleId: "",
        deliveryDateFrom: this.state.deliveryDateFrom,
        deliveryDateTo: this.state.deliveryDateTo,
        driverName: "",
        salesExecutive: "",
        customerName: "",
      });
      this.setState({
        loading: false,
        vehicleId: "",
        deliveryDateFrom: this.state.deliveryDateFrom,
        deliveryDateTo: this.state.deliveryDateTo,
        driverName: "",
        salesExecutive: "",
        customerName: "",
        currentPage: 1,
      });
    }
  };

  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Space>
              <CompanyAutocomplete
                className="searchInput"
                value={
                  this.state.companyVal_Lab ? this.state.companyVal_Lab : null
                }
                onChange={(value) => this.handleChange(value)}
                style={{ width: 140 }}
                status={this.state.companyFieldHighlight ? "error" : false}
              />

              <Select
                className="searchInput"
                value={this.state.vehicleId ? this.state.vehicleId : null}
                placeholder={this.context.translate("_VEHICLES_")}
                style={{ width: 110 }}
                onSelect={async (val) => {
                  await this.setState({ vehicleId: val });
                  this.handleSearch();
                }}
                showSearch
                optionFilterProp="children"
                filterOption={(inputValue, option) => {
                  if (option.children) {
                    return (
                      option.children
                        .toLowerCase()
                        .indexOf(inputValue.toLowerCase()) >= 0
                    );
                  }
                }}
              >
                {this.jobManagementStore?.VehicleList?.map((val) => {
                  return <Option value={val.vehicleId}>{val.vehicleNo}</Option>;
                })}
              </Select>

              <Select
                className="searchInput"
                value={
                  this.state.salesExecutive ? this.state.salesExecutive : null
                }
                placeholder={this.context.translate("_SALES_EXECUTIVE_")}
                style={{ width: 150 }}
                showSearch
                onSelect={async (val) => {
                  await this.setState({ salesExecutive: val });
                  this.handleSearch();
                }}
                fieldNames={{
                  label: "SalesExecutiveName",
                  value: "salespersonId",
                }}
                optionFilterProp="children"
                options={this.jobManagementStore?.getSalesPersonExecutiveArray}
              />

              <Select
                className="searchInput"
                value={this.state.driverName ? this.state.driverName : null}
                placeholder={this.context.translate(
                  "_FLEET_VEHICLE_VEHICLEDETAIL_DRIVER_"
                )}
                style={{ width: 110 }}
                onSelect={async (val) => {
                  await this.setState({ driverName: val });
                  this.handleSearch();
                }}
                showSearch
                optionFilterProp="children"
                filterOption={(inputValue, option) => {
                  if (option.children) {
                    return (
                      option.children
                        .toLowerCase()
                        .indexOf(inputValue.toLowerCase()) >= 0
                    );
                  }
                }}
              >
                {this.jobManagementStore?.getDrivers?.map((val) => {
                  return <Option value={val.driverId}>{val.driverName}</Option>;
                })}
              </Select>

              <Input
                style={{
                  width: 270,
                  borderRadius: "25px",
                }}
                value={this.state.customerName ? this.state.customerName : ""}
                className="searchInput"
                placeholder={this.context.translate(
                  "_CUSTOMER_NAME_INVOICE_NO_"
                )}
                onChange={async (e) => {
                  await this.setState({ customerName: e.target.value });
                }}
              />

              <DatePicker
                className="searchInput"
                value={
                  this.state.deliveryDateFrom
                    ? dayjs(this.state.deliveryDateFrom)
                    : null
                }
                defaultValue={dayjs()}
                style={{ width: 130, borderRadius: "25px" }}
                format="DD-MM-YYYY"
                name="deliveryDateFrom"
                onChange={(date) => {
                  if (date === null) {
                    this.setState({ deliveryDateFrom: "" });
                  } else {
                    const format = "YYYY-MM-DD";
                    this.setState({ deliveryDateFrom: date.format(format) });
                  }
                }}
              />

              <DatePicker
                value={
                  this.state.deliveryDateTo
                    ? dayjs(this.state.deliveryDateTo)
                    : null
                }
                className="searchInput"
                defaultValue={dayjs()}
                format="DD-MM-YYYY"
                style={{ width: 130, borderRadius: "25px" }}
                name="deliveryDateTo"
                onChange={(date) => {
                  if (date === null) {
                    this.setState({ deliveryDateTo: "" });
                  } else {
                    const format = "YYYY-MM-DD";
                    this.setState({ deliveryDateTo: date.format(format) });
                  }
                }}
              />
              <Button
                icon={<SearchOutlined />}
                type="primary"
                onClick={async () => {
                  console.log("object");
                  await this.searchClick();
                }}
              ></Button>
            </Space>

            <Space>
              <Tooltip
                title={this.context.translate("_REFRESH_")}
                placement="bottom"
              >
                <Image
                  style={{
                    height: 18,
                    marginInlineEnd: "30px",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  src={refreshIcon}
                  onClick={() => this.refreshList()}
                ></Image>
              </Tooltip>
              <Button
                className="uploadExcelButton"
                onClick={() => this.setState({ showUpload: true })}
              >
                <Tooltip
                  title={this.context.translate("_UPLOAD_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                    }}
                    src={uploadIcon}
                  />
                </Tooltip>
              </Button>
              <Dropdown
                overlayClassName="export-dropdown"
                menu={this.ExportMenuProps}
              >
                <Image
                  style={{ height: 18, alignItems: "center" }}
                  src={kebabIcon}
                ></Image>
              </Dropdown>

              {this.props.canCreate("jobmanagementlist") && (
                <Button
                  className="addButtonClass"
                  onClick={() =>
                    this.setState({ openJobmanagementForm: true, Id: "" })
                  }
                >
                  <Image
                    style={{ marginInlineEnd: "5px", width: 13 }}
                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                  ></Image>
                  {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
                </Button>
              )}
            </Space>
          </Row>

          <ListTable
            rowSelection={{
              selectedRowKeys: this.state.jobId,
              onChange: async (selectedRowKeys, selectedRows) => {
                // await this.setState({})
                await this.setState({ jobId: selectedRowKeys });
              },
            }}
            rowKey="Id"
            current={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.jobManagementStore?.total}
            columns={this.columns}
            dataSource={this.jobManagementStore?.jobManagement}
            loading={this.jobManagementStore?.loading}
            onChange={this.handleTableChange}
          />

          {this.state.showUpload && (
            <>
              <Drawer
                className="uploadExcelDrawer"
                width={716}
                closeIcon={false}
                open={this.state.showUpload}
                placement={this.context.locale.language === "english" ? "right" : "left"}
                footer={false}
                title={
                  <div className="uploadExcelTitle">
                    <Image
                      style={{ height: "100px" }}
                      src={UploadTitleIcon}
                    ></Image>
                    <span>
                      {" "}
                      {this.context.translate("_UPLOAD_EXCEL_TITLE_")}
                    </span>
                  </div>
                }
                maskClosable={false}
                onOk={() => this.setState({ showUpload: false })}
                onCancel={() =>
                  this.setState({
                    showUpload: false,
                    excelFile: "",
                    companyId: "",
                  })
                }
              >
                <Form
                  name="excelimport"
                  layout="vertical"
                  onFinish={this.onExcelSubmit}
                  style={{ margin: "16px 0px", overflow: "Y" }}
                >
                  {(this.props.getUserData().isadmin === -1 ||
                    this.props.getUserData().isadmin === 3) && (
                    <Form.Item
                      name="companyId"
                      className="uploadCompany"
                      label={
                        <span>
                          {this.context.translate("_ACCOUNT_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      rules={[{ required: true }]}
                      required={false}
                    >
                      <CompanyAutocomplete
                        onChange={(companyId) => {
                          this.setState({ companyId: companyId.value });
                        }}
                      />
                    </Form.Item>
                  )}

                  <Form.Item
                    className="uploadCompany"
                    label={
                      <span>
                        {this.context.translate("_ASSIGN_JOB_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    // label={this.context.translate("_ASSIGN_JOB_")}
                    name="jobType"
                    rules={[{ required: true }]}
                    required={false}
                  >
                    <Select>
                      <Select.Option value="Driver">
                        {this.context.translate(
                          "_FLEET_DASHBORD_HISTORY_TOOLTIP_DRIVER_"
                        )}
                      </Select.Option>

                      {/* <Select.Option value="Sales Person">
                        {this.context.translate("_SALES_PERSON_")}
                      </Select.Option> */}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    className="uploadCompany"
                    label={
                      <span>
                        {this.context.translate("_EXCEL_DETAILS_ID_NAME_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    // label={this.context.translate("_EXCEL_DETAILS_ID_NAME_")}
                    name="detailType"
                    rules={[{ required: true }]}
                    required={false}
                  >
                    <Select>
                      <Select.Option value="id">
                        {this.context.translate("_Id_")}
                      </Select.Option>
                      <Select.Option value="name">
                        {this.context.translate("_FLEET_DASHBORD_NEWPOI_NAME_")}
                      </Select.Option>
                    </Select>
                  </Form.Item>
                  <Dragger
                    style={{ marginTop: "20px" }}
                    showProgress="true"
                    name="excelFile"
                    // action={"http://localhost:3019" + "/jobManagementList/uploadExcel"}
                    action={config.baseURL + "/jobManagementList/uploadExcel"}
                    listType="text"
                    data={{ fileType: "jobimport", fieldName: "excelFile" }}
                    onChange={this.getUploadData}
                    beforeUpload={(file) => {
                      const isExcel =
                        file.type === "application/vnd.ms-excel" ||
                        file.type ===
                          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                      if (!isExcel) {
                        message.error(
                          "You can only upload .xls or .xlsx files!"
                        );
                        return Upload.LIST_IGNORE;
                      }
                      return true;
                    }}
                    // accept=".xls,.xlsx"
                    maxCount={1}
                    onRemove={() =>
                      this.setState({ excelFile: "", fileList: [] })
                    }
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "20px",
                      }}
                    >
                      <div>
                        <Image
                          style={{ width: "90px" }}
                          src={uploadOutlined}
                        ></Image>
                      </div>
                      <div className="uploadFileText">
                        <span>
                          {this.context.translate("_UPLOAD_EXCEL_FILE_")}
                        </span>
                        <p>
                          {this.context.translate("_UPLOAD_TEXT_")}{" "}
                          <span
                            style={{
                              color: "var(--Blue-6, #1890FF)",
                              fontSize: "14px",
                              cursor: "pointer",
                            }}
                          >
                            {this.context.translate("_UPLOAD_TEXT_1_")}{" "}
                          </span>
                          {this.context.translate("_UPLOAD_TEXT_2_")}
                        </p>
                      </div>
                    </div>
                  </Dragger>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      textAlign: "center",
                      marginTop: "16px",
                      paddingBottom: "80px",
                    }}
                  >
                    <div className="sampleDownload">
                      <span>
                        {" "}
                        {this.context.translate("_SAMPLE_DOWNLOAD_")}
                      </span>
                      <p>{this.context.translate("_SAMPLE_EXCEL_DESC_")}</p>
                      <Button
                        onClick={() =>
                          this.jobManagementStore.sampleExcelDriver()
                        }
                      >
                        <Image src={sampleDownloadIcon}></Image>
                        <span style={{ color: "#2563EB", fontSize: "14px" }}>
                          {" "}
                          {this.context.translate("_SAMPLE_DOWNLOAD_")}
                        </span>
                      </Button>
                    </div>

                    <div className="sampleUpload">
                      <span> {this.context.translate("_SAMPLE_UPLOAD_")}</span>
                      <p>{this.context.translate("_SAMPLE_DOWNLOAD_DESC_")}</p>
                      <Button>
                        <Image src={sampleUploadIcon}></Image>
                        <span style={{ color: "#2563EB", fontSize: "14px" }}>
                          {this.context.translate("_SAMPLE_UPLOAD_")}
                        </span>{" "}
                      </Button>
                    </div>
                  </div>

                  <Space className="uploadFooter">
                    <Button
                      className="uploadCancelButton"
                      onClick={() =>
                        this.setState({
                          showUpload: false,
                          excelFile: "",
                          companyId: "",
                        })
                      }
                    >
                      {this.context.translate(
                        "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                      )}
                    </Button>
                    <Button
                      htmlType="submit"
                      className="uploadButton"
                      // onClick={() => this.onExcelSubmit()}
                    >
                      {this.context.translate("_UPLOAD_")}
                    </Button>
                  </Space>
                </Form>
              </Drawer>{" "}
            </>
          )}

          <Modal
            maskClosable={false}
            title={
              <div className="confirmStatusTitle">
                {/* {" "}
                <i
                  style={{ color: "red", fontSize: "18px", marginInlineEnd: "5px" }}
                  class="bi bi-exclamation-triangle"
                ></i>{" "} */}
                <span>{this.context.translate("_FINISH_JOB_")}</span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ showModal: false })}
                />
              </div>
            }
            className="update-statusModal"
            // description="Are you sure to cancel job?"
            centered
            open={this.state.showModal}
            footer={null}
            // onOk={this.confirmStatus}
            width={400}
            closable={false}
          >
            <div className="confirmStatusText">
              <p>Are you sure you want to finish job?</p>
            </div>
            <div className="confirmStatusButtons">
              <Button
                onClick={() => this.setState({ showModal: false })}
                className="confirmStatusCancelButton"
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="confirmStatusOkButton"
                style={{ cursor: "pointer", color: "white" }}
                onClick={(e) => {
                  this.finishJob(this.state.jobId);

                  this.setState({ showModal: false });
                }}
              >
                {this.context.translate(
                  "_FLEET_DASHBORD_VEHICLE_COMMAND_OKBTN_"
                )}
              </Button>
            </div>
          </Modal>

          <Modal
            className="multiTracking-popup"
            maskClosable={false}
            title={
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div
                  style={{
                    padding: "8px",
                    display: "flex",
                    gap: "10px",
                  }}
                >
                  <CompanyAutocomplete
                    onChange={(value) => this.handleChange(value)}
                    allowClear={true}
                    style={{ width: 150 }}
                  />
                  <Input
                    style={{ width: 150 }}
                    //  placeholder="Vehicle"
                    placeholder={this.context.translate("_VEHICLES_")}
                  />

                  <DatePicker defaultValue={dayjs()} format="MM-DD-YYYY" />
                </div>
                <CloseOutlined
                  onClick={() => this.setState({ showmap: false })}
                />
              </div>
            }
            centered
            open={this.state.showmap}
            onCancel={() => this.setState({ showmap: false })}
            footer={null}
            width={750}
          >
            <DisplayLocationMap></DisplayLocationMap>
          </Modal>

          <Modal
            maskClosable={false}
            title={
              <div className="confirmStatusTitle">
                <span>{this.context.translate("_DELETE_JOB_")}</span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ showDeleteModal: false })}
                />
              </div>
            }
            className="update-statusModal"
            // description="Are you sure to cancel job?"
            centered
            open={this.state.showDeleteModal}
            footer={null}
            // onOk={this.confirmStatus}
            width={400}
            closable={false}
          >
            <div className="confirmStatusText">
              <p>{this.context.translate("_SURE_TO_DELETE_")}</p>
            </div>
            <div className="confirmStatusButtons">
              <Button
                onClick={() => this.setState({ showDeleteModal: false })}
                className="confirmStatusCancelButton"
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="confirmStatusOkButton"
                style={{ cursor: "pointer", color: "white" }}
                onClick={(e) => {
                  this.deleteJob(this.state.jobId);

                  this.setState({ showDeleteModal: false, jobId: "" });
                }}
              >
                {this.context.translate(
                  "_FLEET_DASHBORD_VEHICLE_COMMAND_OKBTN_"
                )}
              </Button>
            </div>
          </Modal>

          {this.state.openJobmanagementForm && (
            <Drawer
              className="uploadExcelDrawer"
              width={716}
              closeIcon={false}
              open={this.state.openJobmanagementForm}
              placement={this.context.locale.language === "english" ? "right" : "left"}
              footer={false}
              title={
                <div className="formTitle">
                  {this.context.translate("_JOB_MANAGEMENT_")}
                  <p className="formDescription">
                    {this.context.translate("_JOB_MANAGEMENT_DESC_")}
                  </p>
                </div>
              }
              maskClosable={false}
              onOk={() => this.setState({ openJobmanagementForm: false })}
              onCancel={() =>
                this.setState({ openJobmanagementForm: false, Id: "" })
              }
            >
              <div style={{ height: "100%" }}>
                <JobManagementAdd
                  Id={this.state.Id}
                  response={this.responseMsg}
                  closeModal={this.closeModal}
                />
              </div>
            </Drawer>
          )}

          <Modal
            maskClosable={false}
            title={
              <div className="confirmStatusTitle">
                <span>{this.context.translate("_FLEET_ALERT_")}</span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ showAlertModal: false })}
                />
              </div>
            }
            className="update-statusModal"
            // description="Are you sure to cancel job?"
            centered
            open={this.state.showAlertModal}
            footer={null}
            // onOk={this.confirmStatus}
            width={400}
            closable={false}
          >
            <div className="confirmStatusText">
              <p>{this.context.translate("_SELECT_JOB_")}</p>
            </div>
            <div className="confirmStatusButtons">
              <Button
                className="confirmStatusOkButton"
                style={{ cursor: "pointer", color: "white" }}
                onClick={() => this.setState({ showAlertModal: false })}
              >
                {this.context.translate(
                  "_FLEET_DASHBORD_VEHICLE_COMMAND_OKBTN_"
                )}
              </Button>
            </div>
          </Modal>

          <Modal
            maskClosable={false}
            title={
              <div className="confirmStatusTitle">
                <span>{this.context.translate("_FLEET_ALERT_")}</span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ showCancelJobModal: false })}
                />
              </div>
            }
            className="update-statusModal"
            // description="Are you sure to cancel job?"
            centered
            open={this.state.showCancelJobModal}
            footer={null}
            // onOk={this.confirmStatus}
            width={400}
            closable={false}
          >
            <div className="confirmStatusText">
              <p>Are you sure to cancel job?</p>
            </div>
            <div className="confirmStatusButtons">
              <Button
                onClick={() => this.setState({ showCancelJobModal: false })}
                className="confirmStatusCancelButton"
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="confirmStatusOkButton"
                onClick={() => this.setState({ showCofirmJobModal: true })}
              >
                {this.context.translate(
                  "_FLEET_DASHBORD_VEHICLE_COMMAND_OKBTN_"
                )}
              </Button>
            </div>
          </Modal>

          {this.state.showCofirmJobModal && (
            <Modal
              width={400}
              className="alert-model"
              title={
                <div>
                  {" "}
                  <i
                    style={{
                      color: "red",
                      fontSize: "18px",
                      marginInlineEnd: "5px",
                    }}
                    class="bi bi-exclamation-triangle"
                  ></i>{" "}
                  {this.context.translate("_FLEET_ALERT_")}
                </div>
              }
              open={this.state.showCancelJobModal}
              onCancel={() => this.setState({ showCancelJobModal: false })}
              footer={null}
            >
              <Form layout="vertical" onFinish={this.handleReasonToCancel}>
                <Form.Item
                  label={this.context.translate("_REASON_TO_CANCEL_JOB_")}
                  name="reason"
                  rules={[{ required: true }]}
                >
                  <Input></Input>
                </Form.Item>

                <div className="formBtnGroup">
                  <Button
                    type="primary"
                    className="formSaveButton"
                    htmlType="submit"
                    // loading={this.state.loading}
                  >
                    {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
                  </Button>
                </div>
              </Form>
            </Modal>
          )}
        </div>
        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
JobManagementList.contextType = StoreContext;
export default observer(withRouter(JobManagementList));
